import Funcs from 'common/helpers/Funcs';
import DataConst from 'consts/DataConst';
import fs from 'react-native-fs';
import Realm from 'realm';
import CategoryModel from './models/CategoryModel';
import CustomerModel from './models/CustomerModel';
import ImportOrderModel from './models/ImportOrderModel';
import OrderItemModel from './models/OrderItemModel';
import OrderModel from './models/OrderModel';
import ProductModel from './models/ProductModel';
import SettingModel from './models/SettingModel';
import ProviderModel from './models/ProviderModel';
import UnitModel from './models/UnitModel';
import Configs from 'utils/Configs';

const path = `${fs.DocumentDirectoryPath}`;
const file = `${path}/default.realm`;
const syncFile = `${path}/sync.json`;
Funcs.log('fs.DocumentDirectoryPath', fs.DocumentDirectoryPath);

const config = {
  path: file,
  schema: [ProductModel, CategoryModel, CustomerModel, OrderModel, OrderItemModel, ImportOrderModel, SettingModel, ProviderModel, UnitModel],
  schemaVersion: 17, // Thêm giá nhập vào order item
  migration: (oldRealm: Realm, newRealm: Realm) => {
    const oldOrders = oldRealm.objects(DataConst.MODELS.ORDER);
    const newOrders = newRealm.objects(DataConst.MODELS.ORDER);
    const oldOrderItems = oldRealm.objects(DataConst.MODELS.ORDER_ITEM);
    const newOrderItems = newRealm.objects(DataConst.MODELS.ORDER_ITEM);
    const oldProductObjects = oldRealm.objects(DataConst.MODELS.PRODUCT);
    const newProductObjects = newRealm.objects(DataConst.MODELS.PRODUCT);

    // Change order int => float
    if (oldRealm.schemaVersion < 10) {
      for (let i = 0; i < oldOrders.length; i++) {
        newOrders[i].money = oldOrders[i].money;
      }

      // Change product price to float
      for (let i = 0; i < oldProductObjects.length; i++) {
        newProductObjects[i].sellPrice = oldProductObjects[i].sellPrice;
        newProductObjects[i].buyPrice = oldProductObjects[i].buyPrice;
      }
    }

    // Init order paid = order money
    if (oldRealm.schemaVersion < 12) {
      for (let i = 0; i < oldOrders.length; i++) {
        newOrders[i].paid = oldOrders[i].money;
      }
    }

    // Change product barcode int => string
    if (oldRealm.schemaVersion < 13) {
      for (let i = 0; i < oldProductObjects.length; i++) {
        newProductObjects[i].barcode = oldProductObjects[i].barcode?.toString();
      }
    }

    // Change float to double
    if (oldRealm.schemaVersion < 14) {
      for (let i = 0; i < oldProductObjects.length; i++) {
        newProductObjects[i].sellPrice = oldProductObjects[i].sellPrice;
        newProductObjects[i].sellPrice1 = oldProductObjects[i].sellPrice1 || 0;
        newProductObjects[i].sellPrice2 = oldProductObjects[i].sellPrice2 || 0;
        newProductObjects[i].buyPrice = oldProductObjects[i].buyPrice || 0;
        newProductObjects[i].sold = oldProductObjects[i].sold || 0;
        newProductObjects[i].quantity = oldProductObjects[i].quantity || 0;
      }
      for (let i = 0; i < oldOrders.length; i++) {
        newOrders[i].money = oldOrders[i].money || 0;
        newOrders[i].paid = oldOrders[i].paid || 0;
        newOrders[i].moneyDiscount = oldOrders[i].moneyDiscount || 0;
      }
      for (let i = 0; i < oldOrderItems.length; i++) {
        newOrderItems[i].amount = oldOrderItems[i].amount || 0;
        newOrderItems[i].discount = oldOrderItems[i].discount || 0;
      }
    }

    // 15 Add price in order items
    if (oldRealm.schemaVersion < 15) {
      for (let i = 0; i < oldOrderItems.length; i++) {
        const price = newOrderItems[i].order?.id ? oldOrderItems[i].product.sellPrice : oldOrderItems[i].product.buyPrice;
        newOrderItems[i].price = price - (price * newOrderItems[i].discount) / 100;
      }
    }
  }
};

let instance = null;

const init = async () => {
  try {
    if (Configs.online) return;
    // instance = new Realm(config);
    Funcs.log('Realm init');
    instance = await Realm.open(config);
    Funcs.log('Relam instance', instance);
    Funcs.log('Relam file', file);
  } catch (err) {
    Funcs.log('PATH', fs.DocumentDirectoryPath);
    Funcs.log('ERROR', err);
  }
};

const getInstance = () => {
  if (!instance) init();
  return instance;
};

const convertToObject = (realmObject) => {
  try {
    if (typeof realmObject === 'object' && !realmObject?.objectSchema) return realmObject;
    var object = {};
    var properties = Object.getOwnPropertyNames(realmObject?.objectSchema()?.properties);
    for (var property of properties) {
      try {
        object[property] = realmObject[property];
        if (realmObject[property]?.objectSchema) {
          object[property] = convertToObject(realmObject[property]);
        }
      } catch (err) {
        console.log('ERROR convertToObject 2', err);
      }
    }
    return object;
  } catch (err) {
    console.log('ERROR convertToObject 1', err);
  }
  return null;
};

const convertToObjects = (realmArrayObject) => {
  try {
    const arr = [];
    for (let i = 0; i < realmArrayObject.length; i += 1) {
      arr.push(convertToObject(realmArrayObject[i]));
    }
    return arr;
  } catch (err) {
    console.log('ERROR', err);
  }
  return [];
};

export default {
  path,
  syncFile,
  file,
  config,
  init,
  convertToObject,
  convertToObjects,
  getInstance,

  close: () => {
    if (!instance) return;
    Funcs.log('Close database', instance);
    try {
      instance.close();
      instance = null;
    } catch (err) {
      Funcs.log('ERROR', err);
    }
  },

  write: (func) => {
    if (!instance) return;
    instance.write(func);
  },

  delete: (realmObject) => {
    if (!instance) return;
    instance.write(() => {
      instance.delete(realmObject);
    });
  }
};
